import { c as _c } from "react/compiler-runtime";
import { FileDisplay } from "@/components/display/FileDisplay";
import type { FileDisplayFile } from "@/components/display/FileDisplay/FileDisplay";
import { Dialog, DialogBody, DialogContent, DialogHeader } from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";
import { DownloadIcon } from "lucide-react";
import multiDownload from "multi-download";
import type { ReactNode } from "react";
type Action = {
  disabled?: boolean;
  label: string;
  onClick: () => void;
  icon: React.ReactNode;
};
export function FileDisplayDialog(t0) {
  const $ = _c(25);
  const {
    file,
    setFile,
    actions,
    downloadActions
  } = t0;
  const isFileObject = file && typeof file === "object";
  const isUrlString = file && typeof file === "string";
  const t1 = file !== null;
  let t2;
  if ($[0] !== setFile) {
    t2 = open => {
      if (!open) {
        setFile(null);
      }
    };
    $[0] = setFile;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isFileObject ? file.name : isUrlString ? "File" : "";
  let t4;
  if ($[2] !== actions) {
    t4 = actions?.map(_temp);
    $[2] = actions;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== downloadActions || $[5] !== file || $[6] !== isFileObject || $[7] !== isUrlString) {
    t5 = downloadActions ?? <Button variant="secondary" onClick={async () => {
      if (isFileObject) {
        await multiDownload([file.downloadUrl ?? file.url]);
      } else {
        if (isUrlString) {
          await multiDownload([file]);
        }
      }
    }}><DownloadIcon />Download</Button>;
    $[4] = downloadActions;
    $[5] = file;
    $[6] = isFileObject;
    $[7] = isUrlString;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <DialogHeader title={t3} truncate={true} actions={t6} />;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = isFileObject ? file : undefined;
  const t9 = isUrlString ? file : undefined;
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <DialogBody padding="none"><FileDisplay file={t8} url={t9} /></DialogBody>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7) {
    t11 = <DialogContent size="full">{t7}{t10}</DialogContent>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t1 || $[22] !== t11 || $[23] !== t2) {
    t12 = <Dialog open={t1} onOpenChange={t2}>{t11}</Dialog>;
    $[21] = t1;
    $[22] = t11;
    $[23] = t2;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}
function _temp(action) {
  return <Button key={action.label} variant="secondary" onClick={action.onClick} disabled={action.disabled}>{action.icon}{action.label}</Button>;
}